import globalConfig from '../utiles/globalConfig';
import {
  getHostDefaultPlatformIconImageName,
} from '../utiles/logoPlatformIconImageName';
import ipCheck, { CHECK_IP_LOCATION } from './ipCheck';

const MAIN_HOST = globalConfig.getMainHost();
const CHANGE_PASSPORT_ICON = 'changePassportIcon';
const CHANGE_STORE_SELECT_LOGO = 'changeStoreLogo';
const CHANGE_WEB_STORE_LOGO = 'changeWebStoreLogo';
const CAHNGE_WEB_LOGIN_LOGO = 'changeWebLoginLogo';
export const INIT_LOGO_BY_IP = 'initLogoByIp';
let getImageName = function (gid) {
  let gameId = globalConfig.getHrefParam('gameId') || gid;
  let appLanguage = globalConfig.getLanguages();
  // 鬼語&越南語 顯示 100d
  if (+gameId === 125 && appLanguage === 'vi-VN') {
    return '100d';
    // 日理万机
  } else if (+gameId === 179) {
    return 'krsyua';
    // 修仙在云端
  } else if (+gameId === 193) {
    return 'xxzyd';
  } else if (
    +gameId === 177 &&
    globalConfig.getMainHost() === atob('dHRoZ2FtZS5jb20=')
  ) {
    // 越南日理万机 && tthgame.com
    return 'ynrlwj';
  } else if (+gameId === 201) {
    // 越南精灵盛典
    return 'ynjlsd';
  } else if (+gameId === 267) {
    // c6
    return 'c6';
  } else if (+gameId === 274) {
    // 斗罗3D东南亚版
    return 'slfuntap.com';
  } else if (+gameId === 416) {
    return 'olgamevn.com-user';
  } else {
    return getHostDefaultPlatformIconImageName();
  }
};

// 泰越斗罗h5泰国地区域名、三刷域名logo隐藏
// 2021.10.12 olgamevn因存在多个对外域名，故隐藏默认的sungame的logo
const hideLogoHostArr = [
  atob('M3N5dWEuY29t'),
  atob('ZW5kb21haW5uYW1lLmNvbQ=='),
  atob('ZHJvdXBuaXJlbnQuY29t'),
  atob('b2xnYW1ldm4uY29t'),
];

const IMAGE_NAME = getImageName();

export default {
  state: {
    passportPlatformIcon: `https://gabres.${MAIN_HOST}/platformIcon/${IMAGE_NAME}.png`,
    storeSelectPageIcon: `https://abres.octlib.com/platformIcon/storeLogoText/${IMAGE_NAME}.png`,
    webStoreLogo: `https://abres.octlib.com/platformIcon/brandText/${IMAGE_NAME}.png`,
    webLoginLogo: `https://abres.octlib.com/platformIcon/brandText/${IMAGE_NAME}.png`,
    showPassportLogo: true,
    showStoreSelectPageIcon: true,
    showWebStoreLogo: !hideLogoHostArr.includes(MAIN_HOST),
    showWebLoginLogo: !hideLogoHostArr.includes(MAIN_HOST),
  },
  mutations: {
    [CHANGE_PASSPORT_ICON](state, locationInfo, gameId) {},
    [CHANGE_STORE_SELECT_LOGO](state, locationInfo, gameId) {},
    [CHANGE_WEB_STORE_LOGO](state, locationInfo, gameId) {
      state.showWebStoreLogo = !hideLogoHostArr.includes(MAIN_HOST);
    },
    [CAHNGE_WEB_LOGIN_LOGO](state, locationInfo, gameId) {
      state.showWebLoginLogo = !hideLogoHostArr.includes(MAIN_HOST);
    },
  },
  modules: {
    ipCheck,
  },
  actions: {
    [INIT_LOGO_BY_IP]({ dispatch, commit }, gameId) {
      dispatch(CHECK_IP_LOCATION)
        .then(locationInfo => {
          // commit(CHANGE_PASSPORT_ICON,locationInfo,gameId);
          // commit(CHANGE_STORE_SELECT_LOGO,locationInfo,gameId);
          commit(CHANGE_WEB_STORE_LOGO, locationInfo, gameId);
          commit(CAHNGE_WEB_LOGIN_LOGO, locationInfo, gameId);
        })
        .catch(e => {});
    },
  },
};
